import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleListPage() {
  return (
    <main className="pt-16">
      <section className="py-12 md:py-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">文章资讯</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            文章资讯
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl leading-relaxed">
            了解更多关于医护美学、写真拍摄、角色扮演与美体护理的专业内容
          </p>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-100/80 text-accent-900 text-xs font-medium rounded-md">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h2 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </h2>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.publishedAt}</span>
                    <span>{article.readTime}</span>
                  </div>
                  <div className="flex flex-wrap items-center gap-2 mt-3">
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-background-100 text-foreground-500 text-xs rounded-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}